/**
 * Payment intervals
 *
 * These are the values sent for the interval field
 */
export enum PaymentInterval {
  Monthly = '0',
  Quarterly = '1',
  HalfYearly = '2',
  Yearly = '3',
  /**
   * Special case, as this does not really represent an interval
   * but rather a single payment.
   */
  OneOff = '4',
}

/**
 * Array of intervals that are recurring
 */
export const recurringIntervals = Object.freeze([
  PaymentInterval.Monthly,
  PaymentInterval.Quarterly,
  PaymentInterval.HalfYearly,
  PaymentInterval.Yearly,
]);

/**
 * Interval that is the calculation base for passed.
 *
 * @example
 * // 12 per year (same as 1 per month)
 * { calculation_base: 'yearly', amount: 12, ... }
 */
export enum IntervalBase {
  Monthly = 'monthly',
  Yearly = 'yearly',
  /**
   * Amounts are interpreted as to be per interval
   * @deprecated
   */
  PerInterval = 'per_interval',
}
